import { Service } from '@roc/feature-app-core';

const url = {
  GET_AMCS: '/api/v1/roc-valuation/appraisal-payments/amcs',
  LOOKUP_LOANS: '/api/v1/roc-valuation/appraisal-payments/loan-lookup',
  VALIDATE_LOANS: '/api/v1/roc-valuation/appraisal-payments/loan-lookup/validate',
  GENERATE_PAYMENT_LINK: '/api/v1/roc-valuation/appraisal-payments/bulk/payment-link',
  UPDATE_PAYMENT_DETAILS: '/api/v1/roc-valuation/appraisal-payments/bulk/payment-details',
};

export type AppraisalPaymentAmc = {
  amcId: number;
  name: string;
};

export type AppraisalPaymentLoanLookup = {
  loanId: number;
  dealName?: string;
  borrower?: string;
  propertyAddress?: string;
  selectedAmcId: number;
  selectedAmcName?: string;
  valuationCount: number;
  appraisalCost: number;
  clientValuationReferenceIds: number[];
  valuationOrders?: {
    clientValuationReferenceId: number;
    amount: number;
    rush: boolean;
  }[];
};

export type AppraisalPaymentLoanValidationError = {
  loanId: number;
  reason: string;
};

export type AppraisalPaymentLoanValidationResponse = {
  validLoans: AppraisalPaymentLoanLookup[];
  invalidLoans: AppraisalPaymentLoanValidationError[];
};

export type BulkAppraisalPaymentOrderRequest = {
  clientValuationReferenceId: number;
  amount: number;
  rush: boolean;
};

export type BulkAppraisalPaymentLoanRequest = {
  loanId: number;
  orders: BulkAppraisalPaymentOrderRequest[];
};

export type BulkAppraisalPaymentLinkResponse = {
  paymentId: number;
  paymentLink: string;
  subtotal: number;
  rushFees: number;
  total: number;
  loanCount: number;
  valuationOrderCount: number;
};

export class BulkAppraisalPaymentsService extends Service {
  getAmcs() {
    return this.get(url.GET_AMCS, undefined, { disableGlobalLoading: true });
  }

  lookupLoans(amcId: number, term: string) {
    return this.get(
      url.LOOKUP_LOANS,
      {
        amcId,
        term,
        limit: 10,
      },
      { disableGlobalLoading: true }
    );
  }

  validateLoans(amcId: number, loanIds: number[]) {
    return this.post(
      url.VALIDATE_LOANS,
      {
        amcId,
        loanIds,
      },
      undefined,
      { disableGlobalLoading: true }
    );
  }

  generatePaymentLink(amcId: number, loans: BulkAppraisalPaymentLoanRequest[]) {
    return this.post(
      url.GENERATE_PAYMENT_LINK,
      {
        amcId,
        loans,
      },
      undefined,
      { disableGlobalLoading: true }
    );
  }

  updatePaymentDetails(amcId: number, loans: BulkAppraisalPaymentLoanRequest[]) {
    return this.put(
      url.UPDATE_PAYMENT_DETAILS,
      {
        amcId,
        loans,
      },
      undefined,
      undefined,
      { disableGlobalLoading: true }
    );
  }
}
